import "./App.css";
// importing components from react-router-dom package
import {
BrowserRouter as Router,
Switch,
Route,
Redirect,
} from "react-router-dom";

// import Home component
import Home from "./components/Home";
import E2dashboard from "./components/E2dashboard";
// import About component
import About from "./components/About";
import AboutMe from "./components/AboutMe";
// import ContactUs component
import ContactUs from "./components/ContactUs";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Termsnconditions from "./components/Termsnconditions";
import LearningCenter from "./components/LearningCenter";
import Operational_Excellence_ViewAll from "./components/Operational_Excellence_ViewAll";
import PowerLectures from "./components/PowerLectures";
import LeadersTalk from "./components/LeadersTalk";
import LatestNews from "./components/LatestNews";
import Login from "./components/Login";
import ResetPassword from "./components/ResetPassword";
import ConfirmPassword from "./components/ConfirmPassword";
import Policies_HR from "./components/Policies_HR";
import IT_Policies from "./components/IT_Policies";
import Corporate_Policy from "./components/Corporate_Policy";
import LndMantra_ViewAll from "./components/LndMantra_ViewAll";
import LearningCenter_DigitalLearning from "./components/LearningCenter_DigitalLearning";
import EventWockhardtList from "./components/EventWockhardtList";
import VisionMission from "./components/VisionMission";
import LeaderShipTeam from "./components/LeaderShipTeam";
import SummaryWockhardtHistory from "./components/SummaryWockhardtHistory";
import SummaryWockhardtBusiness from "./components/SummaryWockhardtBusiness";
import RnDCenter from "./components/RnDCenter";
import AwardsList from "./components/AwardsList";
import ErrAwardsList from "./components/ErrAwardsList";
import PhotographAwardsList from "./components/PhotographAwardsList";
import VideoAwardsList from "./components/VideoAwardsList";
import FormsListUsers from "./components/FormsListUsers";
import HRPolicyList from "./components/HRPolicyList";
import ITPolicyList from "./components/ITPolicyList";

import LearningCenterVideoList from "./components/LearningCenterVideoList";
import CoorporatePolicyList from "./components/CoorporatePolicyList";
import ManufacturingPlants from "./components/ManufacturingPlants";
import Bod from "./components/Bod";
import BodDetail from "./components/BodDetail";
import TrainingCalender from "./components/TrainingCalender";
import HR_Helpdesk from "./components/HR_Helpdesk";
import HR_Helpdesk_List from "./components/HR_Helpdesk_List";
import IT_Helpdesk from "./components/IT_Helpdesk";
import ExtensionList from "./components/ExtensionList";
import Infinity from "./components/Infinity";
import Profile from "./components/Profile";
import QuickLinks from "./components/QuickLinks";
import ProtectedRoute from "./components/ProtectedRoute";
import Modal from "./components/Modal";
import ApprovalNotifications from "./components/ApprovalNotifications";
import GenerateEvisitingCard from "./components/GenerateEvisitingCard";
import NewContact from "./components/NewContact";
import ApplicationsListUsers from "./components/ApplicationsListUsers";

function App() {
return (
	<>
	{/* This is the alias of BrowserRouter i.e. Router */}
	<Router>
		<Switch>
		{/* This route is for home component
		with exact path "/home", in component props
		we passes the imported component*/}
		{/*<Route exact path="/home" component={Home} />*/}

		{/* This route is for home component
		with exact path "/", in component props
		we passes the imported component*/}
		{/*<Route exact path="/" component={E2dashboard} />*/}
		<Route path="/approvalnotifications" component={ApprovalNotifications} />
		<Route path="/generateevisitingcard" component={GenerateEvisitingCard} />
		<Route path="/newcontact" component={NewContact} />

		<ProtectedRoute exact path="/home" component={Home} />
        	<ProtectedRoute exact path="/" component={E2dashboard} />

		{/* This route is for login component
		with exact path "/login", in component
		props we passes the imported component*/}
		<Route exact path="/login" component={Login} />

		{/* This route is for quicklinks component
		with exact path "/quicklinks", in component
		props we passes the imported component*/}
		<Route path="/quicklinks" component={QuickLinks} />

		{/* This route is for quicklinks component
		with exact path "/quicklinks", in component
		props we passes the imported component*/}
		<Route path="/modal" component={Modal} />
			
		{/* This route is for about component
		with exact path "/about", in component
		props we passes the imported component*/}
		<Route path="/about" component={About} />

		{/* This route is for resetpassword component
		with exact path "/resetpassword", in component
		props we passes the imported component*/}
		<Route path="/resetpassword" component={ResetPassword} />
		
		{/* This route is for confirmpassword component
		with exact path "/confirmpassword", in component
		props we passes the imported component*/}
		<Route path="/confirmpassword" component={ConfirmPassword} />

		{/* This route is for aboutme component
		with exact path "/aboutme", in component
		props we passes the imported component*/}
		<Route path="/aboutme" component={AboutMe} />

		{/* This route is for profile component
		with exact path "/profile", in component
		props we passes the imported component*/}
		<Route path="/profile" component={Profile} />

		{/* This route is for hr_helpdesk component
		with exact path "/hr_helpdesk", in component
		props we passes the imported component*/}
		<Route path="/hr_helpdesk" component={HR_Helpdesk} />
		
		{/* This route is for hr_helpdesk component
		with exact path "/hr_helpdesk_list", in component
		props we passes the imported component*/}
		<Route path="/hr_helpdesk_list" component={HR_Helpdesk_List} />

		{/* This route is for it_helpdesk component
		with exact path "/it_helpdesk", in component
		props we passes the imported component*/}
		<Route path="/it_helpdesk" component={IT_Helpdesk} />

		{/* This route is for extensionlist component
		with exact path "/extensionlist", in component
		props we passes the imported component*/}
		<Route path="/extensionlist" component={ExtensionList} />


		{/* This route is for infinity component
		with exact path "/infinity", in component
		props we passes the imported component*/}
		<Route path="/infinity" component={Infinity} />

		{/* This route is for trainingcalender component
		with exact path "/trainingcalender", in component
		props we passes the imported component*/}
		<Route path="/trainingcalender" component={TrainingCalender} />

		{/* This route is for learningcenter component
		with exact path "/learningcenter", in component
		props we passes the imported component*/}
		<Route path="/learningcenter" component={LearningCenter} />

		{/* This route is for lndmantraviewall component
		with exact path "/lndmantraviewall", in component
		props we passes the imported component*/}
		<Route path="/lndmantraviewall" component={LndMantra_ViewAll} />

		{/* This route is for operational_excellence component
		with exact path "/operational_excellence", in component
		props we passes the imported component*/}
		<Route path="/operational_excellence" component={Operational_Excellence_ViewAll} />

		{/* This route is for latestnews component
		with exact path "/latestnews", in component
		props we passes the imported component*/}
		<Route path="/latestnews" component={LatestNews} />

		{/* This route is for powerlectures component
		with exact path "/powerlectures", in component
		props we passes the imported component*/}
		<Route path="/powerlectures" component={PowerLectures} />

		{/* This route is for leaderstalk component
		with exact path "/leaderstalk", in component
		props we passes the imported component*/}
		<Route path="/leaderstalk" component={LeadersTalk} />
		
		
		{/* This route is for leaderstalk component
		with exact path "/learningcenter_digitallearning", in component
		props we passes the imported component*/}
		<Route path="/learningcenter_digitallearning" component={LearningCenter_DigitalLearning} />
		
		
		{/* This route is for visionmission component
		with exact path "/vissionmission", in component
		props we passes the imported component*/}
		<Route path="/visionmission" component={VisionMission} />
		
		
		
		
		{/* This route is for visionmission component
		with exact path "/summarywockhardthistory", in component
		props we passes the imported component*/}
		<Route path="/summarywockhardthistory" component={SummaryWockhardtHistory} />
		
		{/* This route is for visionmission component
		with exact path "/summarywockhardtbusiness", in component
		props we passes the imported component*/}
		<Route path="/summarywockhardtbusiness" component={SummaryWockhardtBusiness} />
		
		{/* This route is for visionmission component
		with exact path "/rndcenter", in component
		props we passes the imported component*/}
		<Route path="/rndcenter" component={RnDCenter} />
		
		
		
		{/* This route is for visionmission component
		with exact path "/awardslist", in component
		props we passes the imported component*/}
		<Route path="/awardslist" component={AwardsList} />
		
		{/* This route is for visionmission component
		with exact path "/errawardslist", in component
		props we passes the imported component*/}
		<Route path="/errawardslist" component={ErrAwardsList} />
		
		{/* This route is for visionmission component
		with exact path "/photographawardslist", in component
		props we passes the imported component*/}
		<Route path="/photographawardslist" component={PhotographAwardsList} />
		
		{/* This route is for visionmission component
		with exact path "/videoawardslist", in component
		props we passes the imported component*/}
		<Route path="/videoawardslist" component={VideoAwardsList} />
		
		
		{/* This route is for visionmission component
		with exact path "/formslist", in component
		props we passes the imported component*/}
		<Route path="/formslist" component={FormsListUsers} />
		
		{/* This route is for visionmission component
		with exact path "/applicationslist", in component
		props we passes the imported component*/}
		<Route path="/applicationslist" component={ApplicationsListUsers} />
		
		{/* This route is for visionmission component
		with exact path "/hrpolicylist", in component
		props we passes the imported component*/}
		<Route path="/hrpolicylist" component={HRPolicyList} />
		
		{/* This route is for visionmission component
		with exact path "/itpolicylist", in component
		props we passes the imported component*/}
		<Route path="/itpolicylist" component={ITPolicyList} />
		
		{/* This route is for visionmission component
		with exact path "/corporatepolicylist", in component
		props we passes the imported component*/}
		<Route path="/corporatepolicylist" component={CoorporatePolicyList} />
		
		
		{/* This route is for visionmission component
		with exact path "/videolists", in component
		props we passes the imported component*/}
		<Route path="/videolists" component={LearningCenterVideoList} />
		
		
		{/* This route is for visionmission component
		with exact path "/leadershipteam", in component
		props we passes the imported component*/}
		<Route path="/leadershipteam" component={LeaderShipTeam} />
		
		{/* This route is for visionmission component
		with exact path "/manufacturingplants", in component
		props we passes the imported component*/}
		<Route path="/manufacturingplants" component={ManufacturingPlants} />
		
		
		{/* This route is for bod component
		with exact path "/bod", in component
		props we passes the imported component*/}
		<Route path="/bod" component={Bod} />
		
		{/* This route is for bod component
		with exact path "/boddetail", in component
		props we passes the imported component*/}
		<Route path="/boddetail" component={BodDetail} />
		
		{/* This route is for leaderstalk component
		with exact path "/event-wockhardt-list", in component
		props we passes the imported component*/}
		<Route path="/event-wockhardt-list" component={EventWockhardtList} />
			
		{/* This route is for contactus component
		with exact path "/contactus", in
		component props we passes the imported component*/}
		<Route path="/contactus" component={ContactUs} />

		{/* This route is for privacypolicy component
		with exact path "/privacypolicy", in
		component props we passes the imported component*/}
		<Route path="/privacypolicy" component={PrivacyPolicy} />

		{/* This route is for hr-policies component
		with exact path "/hr-policies", in
		component props we passes the imported component*/}
		<Route path="/hr-policies" component={Policies_HR} />

		{/* This route is for it-policies component
		with exact path "/it-policies", in
		component props we passes the imported component*/}
		<Route path="/it-policies" component={IT_Policies} />

		{/* This route is for corporate-policies component
		with exact path "/corporate-policies", in
		component props we passes the imported component*/}
		<Route path="/corporate-policies" component={Corporate_Policy} />

		{/* This route is for termsnservices component
		with exact path "/termsnservices", in
		component props we passes the imported component*/}
		<Route path="/termsnservices" component={Termsnconditions} />
			
		{/* If any route mismatches the upper
		route endpoints then, redirect triggers
		and redirects app to home component with to="/" */}
		<Redirect to="/" />
		</Switch>
	</Router>
	</>
);
}

export default App;

